<template>
  <!-- 固定在内容区域的底部，不随滚动条移动，常用于长页面的数据搜集和提交工作。 -->
  <div
    class="footer-toolbar"
    :style="{ width: `calc(100% - ${collapsed ? 80 : 256}px)` }"
  >
    <div style="float: left">
      <slot name="extra">{{ extra }}</slot>
    </div>

    <div style="float:right;">
      <span class="popover-wrapper">
        <a-popover
          title="表单校验信息"
          v-if="fieldsErrors.length"
          trigger="click"
          :getPopupContainer="trigger => trigger.parentNode"
        >
          <template slot="content">
            <a-list itemLayout="horizontal" :dataSource="fieldsErrors">
              <a-list-item
                slot="renderItem"
                slot-scope="item"
                @click="validateFieldsAndScroll(item.key, item.formName)"
                style="cursor: pointer;"
                class="error-item"
              >
                {{ item.msg }}
              </a-list-item>
            </a-list>
          </template>
          <span style="color: #f5222d; cursor: pointer; margin-right: 20px;">
            <a-icon type="exclamation-circle" />
            {{ fieldsErrors.length }}
          </span>
        </a-popover>
      </span>

      <slot></slot>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'FooterToolBar',
  data() {
    return {}
  },
  mounted() {},
  computed: {
    ...mapGetters('app', ['collapsed']),
  },
  props: {
    fieldsErrors: {
      type: Array,
      default: function() {
        return []
      },
    },
    extra: {
      type: [String, Object],
      default: '',
    },
  },
  methods: {
    validateFieldsAndScroll(key, formName) {
      this.$emit('handleFieldErrorClick', { key, formName })
    },
  },
}
</script>

<style lang="less" scoped>
.footer-toolbar {
  position: fixed;
  width: 100%;
  bottom: 0;
  right: 0;
  height: 56px;
  line-height: 56px;
  -webkit-box-shadow: 0 -1px 2px rgba(0, 0, 0, 0.03);
  box-shadow: 0 -1px 2px rgba(0, 0, 0, 0.03);
  background: #fff;
  border-top: 1px solid #e8e8e8;
  padding: 0 24px;
  z-index: 9;
  transition: all 0.2s ease 0s;
}

.popover-wrapper {
  /deep/ .ant-popover-inner-content {
    min-width: 256px;
    max-height: 290px;
    padding: 0;
    overflow: auto;
  }
}

.error-item {
  padding: 8px 16px;
  list-style: none;
  border-bottom: 1px solid #e8e8e8;
  transition: all 0.3s;

  &:hover {
    background: #e6f7ff;
  }
}
</style>
